import React from 'react';
import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import SectionMessage from '@atlaskit/section-message/message';

import { i18n } from '../../widgetMacroI18n.ts';
import type { EmbedDescriptor } from '../../widgetMacroTypes.ts';

const styles = cssMap({
	root: {
		display: 'inline-block',
	},
});

type Props = {
	descriptor: EmbedDescriptor;
};

/**
 * Renders the generic unsupported-provider error fallback. Shown when no
 * provider matcher claims the URL, or when the URL targets a blocked internal
 * Atlassian domain.
 */
export const ErrorEmbed = ({ descriptor }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.root} testId="widget-macro-error">
			<SectionMessage appearance="warning">
				{formatMessage(i18n.unsupportedProvider, {
					url: descriptor.hostLabel ?? descriptor.embedUrl,
				})}
			</SectionMessage>
		</Box>
	);
};
